import React, { ReactNode } from "react";
import { Flyout, FlyoutContent } from "@amzn/stencil-react-components/flyout";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "../../typography";
import "../style.scss";

interface TaskDetailsProps {
  detailsTitle: string;
  bundle: any;
  buttons: ReactNode;
  flyoutContent: ReactNode;
  isTaskDetailsViewOpen: boolean;
  closeTaskDetailsView: () => void;
  duration?: number;
}
export const TaskDetails = ({
  detailsTitle,
  bundle,
  buttons,
  flyoutContent,
  isTaskDetailsViewOpen,
  closeTaskDetailsView,
  duration,
}: TaskDetailsProps) => {
  const details = bundle.getMessage("Checklist-CardControlled-DetailsTitle");
  const timeComplete = bundle.formatMessage("checklist-General-Mins", {
    minutes: duration,
  });
  return (
    <Flyout isOpen={isTaskDetailsViewOpen} close={closeTaskDetailsView}>
      <FlyoutContent
        titleText={details}
        buttons={[
          <Col width={"100%"} key={"details-buttons"}>
            {buttons}
          </Col>,
        ]}
        onCloseButtonClick={closeTaskDetailsView}
      >
        <Col className={"flyout-banner"} gridGap={"1rem"}>
          <Row padding={"1rem 1rem 0 1rem"} width={"80%"}>
            <Text fontSize="T400">{detailsTitle}</Text>
          </Row>
          <Row padding={"0 1rem 0 1rem"}>
            <Text fontSize="T200">{duration && timeComplete}</Text>
          </Row>
        </Col>
        {flyoutContent}
      </FlyoutContent>
    </Flyout>
  );
};
